import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import AppShell from "@/components/layout/AppShell";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DRE from "@/pages/DRE";
import Consolidado from "@/pages/Consolidado";
import FluxoCaixa from "@/pages/FluxoCaixa";
import Lancamentos from "@/pages/Lancamentos";
import ContasPagar from "@/pages/ContasPagar";
import MetaRealizado from "@/pages/MetaRealizado";
import Fechamento from "@/pages/Fechamento";
import Empresas from "@/pages/Empresas";
import Projetos from "@/pages/Projetos";
import CentrosCusto from "@/pages/CentrosCusto";
import Categorias from "@/pages/Categorias";
import Configuracoes from "@/pages/Configuracoes";
import ImportarFluxo from "@/pages/ImportarFluxo";
import Cobranca from "@/pages/Cobranca";
import Contratos from "@/pages/Contratos";
import Cursos from "@/pages/Cursos";
import Usuarios from "@/pages/Usuarios";
import RadarAnual from "@/pages/RadarAnual";
import Relatorios from "@/pages/Relatorios";
import ControladoriaDespesas from "@/pages/ControladoriaDespesas";
import ControladoriaCustos from "@/pages/ControladoriaCustos";

const Protected = ({ children, requireMaster }) => (
  <ProtectedRoute requireMaster={requireMaster}>{children}</ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                <Route index element={<Protected><Dashboard /></Protected>} />
                <Route path="/dre" element={<Protected><DRE /></Protected>} />
                <Route path="/consolidado" element={<Protected><Consolidado /></Protected>} />
                <Route path="/fluxo-caixa" element={<Protected><FluxoCaixa /></Protected>} />
                <Route path="/lancamentos" element={<Protected><Lancamentos /></Protected>} />
                <Route path="/contas-pagar" element={<Protected><ContasPagar /></Protected>} />
                <Route path="/contas-receber" element={<Protected><Cobranca /></Protected>} />
                <Route path="/meta-realizado" element={<Protected><MetaRealizado /></Protected>} />
                <Route path="/fechamento" element={<Protected><Fechamento /></Protected>} />
                <Route path="/empresas" element={<Protected><Empresas /></Protected>} />
                <Route path="/fontes-receita" element={<Protected><Projetos /></Protected>} />
                <Route path="/projetos" element={<Protected><Projetos /></Protected>} />
                <Route path="/importar-fluxo" element={<Protected><ImportarFluxo /></Protected>} />
                <Route path="/cobranca" element={<Protected><Cobranca /></Protected>} />
                <Route path="/contratos" element={<Protected><Contratos /></Protected>} />
                <Route path="/cursos" element={<Protected><Cursos /></Protected>} />
                <Route path="/radar-anual" element={<Protected><RadarAnual /></Protected>} />
                <Route path="/relatorios" element={<Protected><Relatorios /></Protected>} />
                <Route path="/controladoria/despesas" element={<Protected><ControladoriaDespesas /></Protected>} />
                <Route path="/controladoria/custos" element={<Protected><ControladoriaCustos /></Protected>} />
                <Route path="/centros-custo" element={<Protected><CentrosCusto /></Protected>} />
                <Route path="/categorias" element={<Protected><Categorias /></Protected>} />
                <Route path="/configuracoes" element={<Protected><Configuracoes /></Protected>} />
                <Route path="/usuarios" element={<Protected requireMaster><Usuarios /></Protected>} />
                <Route path="/dashboard" element={<Navigate to="/" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
